import { VIEW_MODE } from "constants/navigation";
import { useResetTokenValidityQuery } from "services/api/connectionApi";
import { selectToken } from "store/Selectors/appStateSelector";
import { useAppSelector } from "./StoreHooks";

const TOKEN_RENEWAL_DELAY = 15 * 6000;

export function useResetTokenValidity(viewMode: string) {
  const token = useAppSelector(selectToken);
  useResetTokenValidityQuery(token, {
    skip: viewMode == VIEW_MODE.NORMAL,
    pollingInterval: TOKEN_RENEWAL_DELAY,
  });
}
